// Class: openfl.display.IDisplayObjectLoader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IDisplayObjectLoader = function() {}

// Meta

IDisplayObjectLoader.__name__ = "openfl.display.IDisplayObjectLoader";
IDisplayObjectLoader.__isInterface__ = true;
IDisplayObjectLoader.prototype = {
	
};
IDisplayObjectLoader.prototype.__class__ = IDisplayObjectLoader.prototype.constructor = $hxClasses["openfl.display.IDisplayObjectLoader"] = IDisplayObjectLoader;

// Init



// Statics




// Export

exports.default = IDisplayObjectLoader;